
















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ApexOptions} from "apexcharts";
import ApexPt from 'apexcharts/dist/locales/pt-br.json';

interface TooltipCustomData {
  series: number[][];
  seriesIndex: number;
  dataPointIndex: number;
  w: {
    globals: {
      seriesX: number[][];
      colors: string[];
      seriesNames: string[];
    }
  }
}

@Component
export default class GraficoCadastro extends Vue {
  @Prop() public readonly data!: CadastroData;
  @Prop() public readonly interval!: 'month' | 'day';

  get tooltipFormat(): string {
    switch (this.interval) {
      case 'month': return 'MMMM [de] YYYY';
      default: return 'dddd, DD [de] MMMM [de] YYYY';
    }
  }

  get axisFormat(): string {
    switch (this.interval) {
      case 'month': return 'MMM/YY';
      default: return 'DD/MMM';
    }
  }

  get options(): ApexOptions {
    return {
      chart: {
        locales: [ApexPt],
        defaultLocale: 'pt-br',
        fontFamily: '',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        gradient: {
          opacityFrom: .65,
          opacityTo: 0,
        }
      },
      grid: {
        show: false,
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
      },
      legend: {
        position: "top",
        floating: true,
        offsetY: 0,
        onItemClick: {
          toggleDataSeries: false,
        },
      },
      markers: {
        strokeWidth: 4,
        strokeOpacity: 1,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      tooltip: {
        custom: ({ series, seriesIndex, dataPointIndex, w: { globals: {seriesX} }}: TooltipCustomData) => {
          const hoverAxis = seriesX[seriesIndex][dataPointIndex];

          const label = this.$date(hoverAxis).format(this.tooltipFormat);

          const value: number = series[0][dataPointIndex];

          return `<div class="d-flex py-1 px-2">
                    <span class="px-2 border-right">${label}</span>
                    <span class="px-2">${value}</span>
                  </div>`;
        },
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            month: 'MMM/yy',
            day: 'dd/MMM',
          },
          style: {
            colors: 'rgba(0,0,0,.4)',
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        min: 0,
        floating: true,
        forceNiceScale: true,
        labels: {
          offsetX: 25,
          align: 'left',
          style: {
            colors: 'rgba(0,0,0,.4)',
            fontFamily: 'monospace',
          },
          formatter: (value) => {
            let text = '';
            const amount = 6 - value.toFixed(0).length;
            for (let i = 0; i < amount; i++) {
              text += ' ';
            }
            if (value >= 10000) {
              text += `${(value / 1000)} mil`;
            } else {
              text += ` ${value}`;
            }
            return text;
          }
        },
      }
    };
  }

  get series(): ApexAxisChartSeries {
    return [
      {
        data: (this.data?.data ?? []).map(item => {
          return {
            x: new Date(`${item.ano}-${item.mes}-${item.dia}`).getTime(),
            y: item.valor,
          }
        }),
      },
    ];
  }
}
